import DonationDetails from '@/core/components/DonationDetails/DonationDetails';

export default DonationDetails;
